import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faGithub, faLinkedin, faMediumM, faCodepen } from '@fortawesome/free-brands-svg-icons';

const SocialMedia = () => {
    return (
        <ul className="list-unstyled">
            
            <li>
                <a target="_blank" rel="noreferrer" href="https://github.com/solaimanshadin">
                    <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://medium.com/@solaimanshadin">
                    <FontAwesomeIcon icon={faMediumM}></FontAwesomeIcon>
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/solaiman-shadin/">
                    <FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon>
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://codepen.io/solaimanshadin">
                    <FontAwesomeIcon icon={faCodepen}></FontAwesomeIcon>
                </a>
            </li>
            <li>
                <a target="_blank" rel="noreferrer" href="https://web.facebook.com/dev.shadin">
                    <FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon>
                </a>
            </li>
            
        </ul>
    );
};

export default SocialMedia;